var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1799_1443)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5428 7.75H4.27599C4.42021 5.67587 5.14156 3.99378 5.85688 2.80158C5.97509 2.60456 6.09337 2.4205 6.2092 2.24982C3.72253 2.96097 1.84542 5.11601 1.5428 7.75ZM4.276 9.25H1.5428C1.84542 11.884 3.72258 14.0391 6.20929 14.7502C6.09344 14.5795 5.97512 14.3954 5.85688 14.1983C5.14157 13.0061 4.42023 11.3241 4.276 9.25ZM5.78026 9.25H10.2197C10.0792 10.9855 9.47094 12.4031 8.85688 13.4266C8.55063 13.937 8.24499 14.3457 8 14.6422C7.75501 14.3457 7.44937 13.937 7.14312 13.4266C6.52906 12.4031 5.92079 10.9855 5.78026 9.25ZM10.2198 7.75H5.78025C5.92077 6.01446 6.52905 4.59677 7.14312 3.57332C7.44937 3.06291 7.75501 2.65415 8 2.3577C8.24499 2.65415 8.55063 3.06291 8.85688 3.57332C9.47095 4.59677 10.0792 6.01446 10.2198 7.75ZM11.724 9.25C11.5798 11.3241 10.8584 13.0061 10.1431 14.1983C10.0249 14.3954 9.90656 14.5795 9.79071 14.7502C12.2774 14.0391 14.1546 11.884 14.4572 9.25H11.724ZM14.4572 7.75H11.724C11.5798 5.67587 10.8584 3.99378 10.1431 2.80158C10.0249 2.60456 9.90662 2.4205 9.7908 2.24981C12.2775 2.96096 14.1546 5.11601 14.4572 7.75ZM8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1799_1443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.573f5f8358e912da94d177093bb4a118.svg";
export { ForwardRef as ReactComponent };